import React from 'react'
import { Outlet } from 'react-router'
import { useAuth } from '@/common/hooks/useAuth.ts'
import { ModuleFunction } from '@/features/auth/auth.def.ts'

type ProtectedRoutesProps = {
  requiredPermissions?: ModuleFunction[]
}

export const ProtectedRoutes: React.FC<ProtectedRoutesProps> = ({ requiredPermissions = [] }) => {
  const { checkHasAllPermissions } = useAuth()

  if (!checkHasAllPermissions(requiredPermissions)) {
    throw new Error('Access Denied')
  }

  return <Outlet />
}